// extracted by mini-css-extract-plugin
export default {"wrapper":"Floor_wrapper__hVYc6","wrapperWhite":"Floor_wrapperWhite__77xzv","leftBlock":"Floor_leftBlock__QyMw9","rightBlock":"Floor_rightBlock__DErI9","white":"Floor_white__RpFia"};